<template>
  <ChatItem class="chat__message" :first="first" :last="last" is-hunter>
    <RouterLink :to="content.link">{{ content.label }}</RouterLink>
    <Icon id="arrow" class="chat__icon" />
  </ChatItem>
</template>

<script>
import { Icon } from '@/components/global'
import { ContentPropMixin } from '@/mixins'

import ChatItem from './ChatItem.vue'
import ChatItemPropsMixins from './ChatItemPropsMixins.js'

export default {
  name: 'ChatHunterLink',
  mixins: [ChatItemPropsMixins, ContentPropMixin],
  components: { ChatItem, Icon },
}
</script>
